import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionGroup, SelectionGroupItem, Typography, RegularButton } from 'fronton-react';
import { TFrontendConfigurationItem } from 'entries/common/widgets/context';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { getLabelText } from '../../helpers';
import { Hint } from '../Hint';
import {
  ButtonContainer,
  HeaderContainer,
  LayerContainer,
  LayerThickness,
  SelectionGroupClassname,
  SelectionGroupItemClassname,
  ButtonLabelsWrapper,
  LayingTypeLabelWrapper,
  AdditionalMaterialWrapper,
  ShowMoreButtonContainer,
} from './styles';
import { RESTRICTED_OPTIONS_RENDER_COUNT } from './const';

type TProps = {
  fieldName: string;
  layingType: TFrontendConfigurationItem[];
  onChangeValue?: () => void;
};

export const FrontendConfigurationLayingTypes = ({ fieldName, layingType, onChangeValue }: TProps) => {
  const { control, setValue, getValues } = useFormContext();
  const { mobile } = useBreakpoints() ?? {};
  const [showAllOption, setShowAllOption] = useState(false);
  const { defaultValue, hints, label, options } = layingType[0];

  const [stateOptions, setStateOptions] = useState(options ?? []);

  const handleShowMoreClick = () => {
    const { typeInstallation: typeInstalationValue } = getValues();
    const selectedOption = stateOptions?.filter(el => el.value === typeInstalationValue) || [];
    const otherOptions = stateOptions?.filter(el => el.value !== typeInstalationValue) || [];
    setStateOptions(() => (showAllOption ? [...selectedOption, ...otherOptions] : [...stateOptions]));
    setShowAllOption(prev => !prev);
  };

  const defaultOptionsCount = stateOptions?.slice(0, RESTRICTED_OPTIONS_RENDER_COUNT);
  const optionsToRender = showAllOption ? stateOptions : defaultOptionsCount;
  const hasHints = !!hints && hints.length > 0;

  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="h3" color="text-primary">
            {getLabelText(label)}
          </Typography>
          {hasHints ? <Hint content={hints} /> : null}
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name={fieldName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectionGroup
              active={value || Number(defaultValue)}
              onChange={(_, layingTypeValue) => {
                onChange();
                setValue(fieldName, layingTypeValue);
                onChangeValue?.();
              }}
              variant="outline"
              size={mobile ? 's' : 'm'}
              className={SelectionGroupClassname}>
              {optionsToRender?.map(layingTypeItem => (
                <SelectionGroupItem
                  className={SelectionGroupItemClassname}
                  key={layingTypeItem.value}
                  value={layingTypeItem.value}
                  data-testid={`${layingTypeItem.value}-laying-type-select`}>
                  <LayerThickness>
                    <ButtonLabelsWrapper>
                      <LayingTypeLabelWrapper>
                        <Typography variant="m" size="body_long" color="text-primary">
                          {getLabelText(layingTypeItem.label)}
                        </Typography>
                      </LayingTypeLabelWrapper>
                      <AdditionalMaterialWrapper>
                        <Typography size="body_long" variant="s" color="text-secondary">
                          {getLabelText(layingTypeItem.description)}
                        </Typography>
                      </AdditionalMaterialWrapper>
                    </ButtonLabelsWrapper>
                  </LayerThickness>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
          )}
        />
        {stateOptions && stateOptions.length > RESTRICTED_OPTIONS_RENDER_COUNT ? (
          <ShowMoreButtonContainer>
            <RegularButton size="m" variant="secondary" wide onClick={handleShowMoreClick}>
              {showAllOption ? 'Скрыть' : `Ещё ${stateOptions?.length - RESTRICTED_OPTIONS_RENDER_COUNT}`}
            </RegularButton>
          </ShowMoreButtonContainer>
        ) : null}
      </LayerContainer>
    </>
  );
};
